'use strict';

module.exports = ['Yelp', 'Tripadvisor', 'Google'];